import { graphql } from '@/generated/gql';

export const BASE_ORDER_LIST_QUERY = graphql(/* GraphQL */ `
  query BaseOrderList(
    $offset: Int
    $limit: Int
    $filter: JSON
    $order: [OrderSortOrder!]
    $skipExport: Boolean = false
  ) {
    orders(offset: $offset, limit: $limit, filter: $filter, order: $order) {
      nodes {
        id
        externalId
        supplierName
        supplierId
        supplierExternalId
        supplierIndustry {
          id
          name
        }
        supplierEmployeeCount
        supplierLegalType {
          id
          name
        }
        supplierAddress {
          city
          street
          postalCode
          countryCode
        }

        contractReceivedProposalsCount
        contractAverageValueContribution
        orderCreationDate
        contractValidFrom
        contractValidTo
        orderProductCount
        orderProductList @skip(if: $skipExport) {
          id
          name
        }
        orderProductCategoryCount
        orderProductCategoryList @skip(if: $skipExport) {
          id
          name
        }
        orderServiceCount
        orderServiceList @skip(if: $skipExport) {
          id
          name
        }
        representativeCount
        representativeList @skip(if: $skipExport) {
          id
          name
        }
        orderVolume
        links @skip(if: $skipExport) {
          title
          url
        }
        primaryCommodityGroup
        commodityGroupCount
        commodityGroupList @skip(if: $skipExport) {
          id
          name
        }
      }
      totalCount
    }
  }
`);
